import React from 'react';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import {
  HStack,
  Icon, IconButton,
  Select
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';

import FilterValueInput from './FilterValueInput';
import PropertyDropdown from './PropertyDropdown';

import 'react-datepicker/dist/react-datepicker.css';

const SearchAdvancedFilter = ({ isActive, filter, index, searchBlueprint }) => {
  const dispatch = useDispatch();

  const handleOperatorChange = event => {
    dispatch(searchBlueprint.updateStagedFilter({ operator: event.target.value }));
  };

  const icon = !isActive
    ? <Icon as={FiMinusCircle} h={8} w={8} />
    : <Icon as={FiPlusCircle} h={8} w={8} />;

  const variant = !isActive ? 'textBlack' : 'text';

  const onClick = () => (!isActive
    ? dispatch(searchBlueprint.removeAdvancedFilter(index))
    : dispatch(searchBlueprint.addAdvancedFilter()));

  return (
    <HStack alignItems="flex-start" spacing={4} width="100%">
      <PropertyDropdown
        filter={filter}
        searchBlueprint={searchBlueprint}
      />

      <Select
        _active={{
          color: 'primaryScale.600',
          boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`
        }}
        _disabled={{ color: colors.greyScale['500'] }}
        _focus={{ outline: `1px solid ${colors.primaryScale['200']}` }}
        bgColor={colors.greyScale['100']}
        border="0px"
        borderRadius="md"
        color={colors.greyScale['900']}
        flex={1}
        isDisabled={!filter.property || !isActive}
        maxW="304px"
        placeholder={isActive ? 'Operator' : filter?.operator}
        textStyle="bodyMd"
        value={filter?.operator}
        onChange={handleOperatorChange}
      >
        {(filter?.property?.operators || []).map(operator => (
          <option key={operator}>{operator}</option>
        ))}
      </Select>

      <FilterValueInput
        filter={filter}
        isActive={isActive}
        searchBlueprint={searchBlueprint}
      />

      <IconButton
        aria-label="Apply Filters"
        icon={icon}
        isDisabled={!filter.value}
        variant={variant}
        onClick={onClick}
      />
    </HStack>
  );
};

SearchAdvancedFilter.propTypes = {
  isActive: PropTypes.bool,
  filter: PropTypes.shape({
    property: PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.string,
      type: PropTypes.string,
      operator: PropTypes.string,
      operators: PropTypes.arrayOf(PropTypes.string)
    }),
    operator: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  index: PropTypes.number
};

export default SearchAdvancedFilter;
